import {PageView} from "./PageView.js";
import {CompanyJoinWaitLayout} from "../components/layout/CompanyJoinWaitLayout.js";
import {isWebView} from "../store.js";
import {sendMoveMobileSignInPage} from "../../../bridge/renewal-signup/index.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {cancelCompanyJoinRequest} from "../../../apiCall/signup/index.js";

export class CompanyJoinWaitView extends PageView {
    renderLayout() {
        const {mainText = ''} = this.$props;
        this.$props.Layout = new CompanyJoinWaitLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            nextButton:{
                id : "joinCompanyBtn",
                text: i18next.t(common.redirectLoginPage),
                nextPageFunc: this.moveSignInPage.bind(this)
            } ,
            cancelButton : {
                id : "joinCancelBtn",
                text: i18next.t(login.cancelRegisteration),
                cancelFunc: this.cancelJoin.bind(this)
            }
         })
    }
    setEvent() {
        if(Mutil.isAct("joinwait.act")) {
            this.addRefreshPageWarningEvent();
        }
    }

    cancelJoin()  {
        const {
            userId = ""
        } = this.$props;

        Mutil.confirm({
            text: {contents: `${i18next.t(login.cancelRegisterationDesc)} \n  ${i18next.t(login.cancelRegisterationDesc2)}` ,},
            callback: {
                submitFn: async () => {
                    const data = await cancelCompanyJoinRequest(userId);
                    if(Mutil.n2v(data.ERR_CD) !== "0000") {
                        Mutil.toast("error", `${i18next.t(common.errorTryAgain)}`);
                        return
                    }
                    if(isWebView()) {
                        sendMoveMobileSignInPage();
                        return;
                    }
                    SignUpViewChanger.moveIndexHomePage()
                }
            }
        });
    }

    addRefreshPageWarningEvent() {
        const {
            userId = ""
        } = this.$props;

        window.addEventListener("beforeunload", (e) => {
            e.preventDefault();
            Mutil.setCookie("joinUserId", userId, 0, 10 * 1000);
        })
    }

    moveSignInPage() {
        if(isWebView()) {
            sendMoveMobileSignInPage();
            return;
        }
        SignUpViewChanger.moveSignInPage();
    }

    getSectionId() {
        return `companyJoinWaitSection`
    }
    renderComponents() {
        if(!this.$props.Layout) {
            return;
        }
    }
}